<template>
  <div class="PostPictures">
    <div
      class="products-toggle"
      :id="PostPicture.id"
      v-for="PostPicture in PostPictures"
      :key="PostPicture.id"
    >
      <span class="date" v-html="PostPicture.date"></span>
      <h2 v-html="PostPicture.title"></h2>
      <div class="logo">
        <img src="@/assets/images/logo.svg" alt />
      </div>

      <p class="no-toggle-p" v-html="PostPicture.NoToggleP"></p>
      <div class="inner">
        <div
          class="wrapper"
          :id="`wrapper-${PostPicture.id}`"
          @click="checkAria(`wrapper-${PostPicture.id}`, `button-${PostPicture.id}`)"
          v-b-toggle.:id="PostPicture.id"
        >
          <div
            class="img-bg"
            :style="`background: url(${PostPicture.PrevImg}) center / cover no-repeat`"
          ></div>
          <div
            class="img-bg"
            :style="`background: url(${PostPicture.PrevImg}) center / cover no-repeat`"
          ></div>
          <div
            class="img-bg"
            :style="`background: url(${PostPicture.PrevImg}) center / cover no-repeat`"
          ></div>
        </div>
        <button
          :id="`button-${PostPicture.id}`"
          @click="checkAria(`wrapper-${PostPicture.id}`, `button-${PostPicture.id}`)"
          v-b-toggle.:id="PostPicture.id"
          class="more"
        >
          Подробнее
          <img src="@/assets/images/more-arrow.svg" alt />
        </button>
      </div>
      <b-collapse :id="PostPicture.id" class="products_toggle">
        <p v-for="paragraph in PostPicture.paragraphs" :key="paragraph" v-html="paragraph"></p>
        <div class="list" v-if="PostPicture.listTitle">
          <p class="list-title" v-html="PostPicture.listTitle"></p>
          <ul>
            <li v-for="list in PostPicture.list" :key="list" v-html="list"></li>
          </ul>
        </div>
        <div
          class="postPicture-img"
          :style="`background: url(${PostPicture.PrevImg}) center / cover no-repeat`"
        ></div>
        <button
          @click="checkAria(`wrapper-${PostPicture.id}`, `button-${PostPicture.id}`)"
          class="arrow"
          v-b-toggle.:id="PostPicture.id"
        >
          <img src="@/assets/images/toggle-arrow.svg" alt />
        </button>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    PostPictures: Array
  },
  methods: {
    checkAria(wrapper, button) {
      let currentPost = document.getElementById(wrapper);
      let currentButton = document.getElementById(button);
      currentPost.classList.toggle("hide");
      currentButton.classList.toggle("hide");
    }
  }
};
</script>